/* 🤖 this file was generated by svg-to-ts */
export const iconEzeth: {
  name: 'ezeth';
  data: string;
} = {
  name: 'ezeth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.126 0 15.925s7.16 15.924 16 15.924 16-7.126 16-15.924C32 7.126 24.84 0 16 0m0 23.559-5.05-6.788L16 19.617l5.05-2.797zm0-4.708-5.04-2.747h-.01l5.04-7.744 5.05 7.754-5.05 2.737z"/></svg>`,
};
